import React, { useState, useEffect } from "react";
import "./LiveData.css";
import instance from "../../config/axios";
import CardYoutube from "../../components/CardYoutube/CardYoutube";

function Home() {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await instance.get("/api/live/tv/now/youtube");
        setData(res.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="home-container">
      <div className="home-header">
        <div className="live-source-logo">
          <img src="./assets/logo-youtube.png" alt="" width={200} />
        </div>
      </div>
      <CardYoutube data={data} />
    </div>
  );
}

export default Home;
